import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DictionaryModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { CommunicationLanguageFieldComponent } from './communication-language-field/communication-language-field.component';
import { DataProtectionFieldComponent } from './data-protectionn-rule-field/data-protection-field.component';
import { TimeslotFieldComponent } from './timeslot-field/timeslot-field.component';
import { PreloadingFieldComponent } from './preloading-field/preloading-field.component';
import { PickupTruckFieldComponent } from './pickup-truck-field/pickup-truck-field.component';
import { CarrierAutoCompleteFieldComponent } from './carrier-auto-complete-field/carrier-auto-complete-field.component';
import { DictionaryFieldComponent } from './dictionary-field/dictionary-field.component';
import { DictionarySelectFieldComponent } from './dictionary-select-field/dictionary-select-field.component';



@NgModule({
  declarations: [
    CommunicationLanguageFieldComponent,
    DataProtectionFieldComponent,
    TimeslotFieldComponent,
    PreloadingFieldComponent,
    PickupTruckFieldComponent,
    CarrierAutoCompleteFieldComponent,
    DictionaryFieldComponent,
    DictionarySelectFieldComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    DictionaryModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    CommonLayoutModule
  ],
  exports: [
    CommunicationLanguageFieldComponent,
    DataProtectionFieldComponent,
    TimeslotFieldComponent,
    PreloadingFieldComponent,
    PickupTruckFieldComponent,
    CarrierAutoCompleteFieldComponent,
    DictionaryFieldComponent,
    DictionarySelectFieldComponent
  ]
})
export class TmcCommonFieldsModule { }
